module.exports = __webpack_public_path__ + "img/orange_035.7c62ba26.png";